/* eslint-disable quotes */
/* eslint-disable semi */
import httpClient from '@/utils/http-client.js';
import { storeActions } from '@store/actions.constants';
import { storeMutations } from '@store/mutations.constants';

const userActions = {
  [storeActions.addTiers]: ({ commit }, payLoad) => {
    return httpClient.post('/tier/addTier', payLoad).then(
      (res) => {
        commit(storeMutations.tierMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.tierMutation, err);
        return err.response;
      },
    );
  },

  [storeActions.getTierList]: ({ commit }, payLoad) => {
    let url = `/tier/getTierList?page=${payLoad.page}&limit=${payLoad.limit}`
    if(payLoad.sort) url+=`&sort={"${payLoad.sort}":"${payLoad.desc?-1:1}"}`
    if(payLoad.search)url+=`&search=${payLoad.search}`
    if(payLoad.products) url+=`&filter={"Products":"${payLoad.products}"}`
    return httpClient
      .get(
        url,
        payLoad,
      )
      .then(
        (res) => {
          commit(storeMutations.tierList, res);
          return res;
        },
        (err) => {
          commit(storeMutations.tierMutation, err);
          return err.response;
        },
      );
  },
  [storeActions.updateTier]: ({ commit }, payLoad) => {
    return httpClient.post('/tier/updateTier', payLoad).then(
      (res) => {
        commit(storeMutations.tierMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.tierMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getListOfCustomers]: ({ commit }, payLoad) => {
    //debugger;
    console.log("payload is",payLoad);
    return httpClient.get('/tier/getListOfCustomers', payLoad).then(
      (res) => {
       // commit(storeMutations.setCustomers, res);
        return res;
      },
      (err) => {
        //commit(storeMutations.setCustomers, err);
        return err.response;
      },
    );
  },
  [storeActions.getTierById]: ({ commit }, payLoad) => {
    return httpClient.get('/tier/getTierById/' + payLoad.tier_id).then(
      (res) => {
        // commit(storeMutations.licenseMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.licenseMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getProductList]: ({ commit }, payLoad) => {
    return httpClient.get('/tier/getProductList', payLoad).then(
      (res) => {
        commit(storeMutations.tierMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.tierMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getTierCount]: ({ commit }, payLoad) => {
    return httpClient.get('/tier/getTierCount', payLoad).then(
      (res) => {
        commit(storeMutations.setTierCount, res);
        return res;
      },
      (err) => {
        commit(storeMutations.setTierCount, err);
        return err.response;
      },
    );
  },
};
export default { ...userActions };
